module.exports = "<button  class=\"btn _matinet_btn\" (click)=\"addfn.emit()\">Add</button>"